module.exports = __webpack_public_path__ + "static/media/mouth_green.73804018.svg";


//////////////////
// WEBPACK FOOTER
// ./src/res/img/mouth_green.svg
// module id = 133
// module chunks = 0